import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RatingPopupRoutingModule } from './rating-popup-routing.module';
import { RatingPopupComponent } from './rating-popup.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DialogModule } from 'primeng/dialog';
import { RatingModule } from 'primeng/rating';
import { ToastModule } from 'primeng/toast';
import { FormsModule,} from '@angular/forms';

@NgModule({
  declarations: [
    RatingPopupComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RatingPopupRoutingModule,
    RadioButtonModule,
    DialogModule,
    RatingModule,
    ToastModule,
    
  ],
  exports: [
    RatingPopupComponent
  ]
})
export class RatingPopupModule { }
